import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductIdv18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H6V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V6H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M15.25 2.75H12V1.25H15.5C16.1904 1.25 16.75 1.80964 16.75 2.5V6H15.25V2.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 15.25V12H1.25V15.5C1.25 16.1904 1.80964 16.75 2.5 16.75H6V15.25H2.75Z'
      fill='currentColor'
    />
    <path
      d='M15.25 15.25V12H16.75V15.5C16.75 16.1904 16.1904 16.75 15.5 16.75H12V15.25H15.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.05546 5.05546C7.57118 4.53973 8.27065 4.25 9 4.25C9.72935 4.25 10.4288 4.53973 10.9445 5.05546C11.4603 5.57118 11.75 6.27065 11.75 7C11.75 7.72935 11.4603 8.42882 10.9445 8.94454C10.8317 9.05741 10.71 9.15945 10.5812 9.25H11C12.5188 9.25 13.75 10.4812 13.75 12V13H12.25V12C12.25 11.3096 11.6904 10.75 11 10.75H7C6.30964 10.75 5.75 11.3096 5.75 12V13H4.25V12C4.25 10.4812 5.48122 9.25 7 9.25H7.41884C7.28999 9.15945 7.16832 9.05741 7.05546 8.94454C6.53973 8.42882 6.25 7.72935 6.25 7C6.25 6.27065 6.53973 5.57118 7.05546 5.05546ZM9 5.75C8.66848 5.75 8.35054 5.8817 8.11612 6.11612C7.8817 6.35054 7.75 6.66848 7.75 7C7.75 7.33152 7.8817 7.64946 8.11612 7.88388C8.35054 8.1183 8.66848 8.25 9 8.25C9.33152 8.25 9.64946 8.1183 9.88388 7.88388C10.1183 7.64946 10.25 7.33152 10.25 7C10.25 6.66848 10.1183 6.35054 9.88388 6.11612C9.64946 5.8817 9.33152 5.75 9 5.75Z'
      fill='currentColor'
    />
  </Svg>
);

ProductIdv18.displayName = 'ProductIdv18';
export default ProductIdv18;
